export default __webpack_public_path__ + "static/media/Virtual-Machine.550a7e54.svg";